import MatterScheduledMessages from "@/components/features/settings/defaults/MatterScheduledMessages";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_auth/matters/settings/scheduled-messages",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (
    !hasPagePermission(PAGE_PERMISSION_KEYS.mattersSettingsScheduledMessages)
  ) {
    return <GlobalNotAuthorized />;
  }

  return (
    <div className="flex flex-col gap-6">
      <MatterScheduledMessages />
    </div>
  );
}
